import type { ReactNode } from 'react'

import { Spinner } from '@/components/ui/spinner'

/** phone stand-in for a DataTable. hides itself above `sm` the way DataTable
 *  hides itself below it; both share one DataTablePagination outside. */
export function MobileList({
  isLoading = false,
  isEmpty,
  emptyMessage,
  children
}: {
  isLoading?: boolean
  isEmpty: boolean
  emptyMessage: string
  children: ReactNode
}) {
  if (isLoading) {
    return (
      <div className='flex items-center justify-center rounded-md border border-border p-8 sm:hidden'>
        <Spinner />
      </div>
    )
  }

  if (isEmpty) {
    return (
      <div className='rounded-md border border-border p-8 text-center text-sm text-ink-muted sm:hidden'>
        {emptyMessage}
      </div>
    )
  }

  return (
    <ul className='flex flex-col divide-y divide-border rounded-md border sm:hidden'>
      {children}
    </ul>
  )
}
